import { FlashContextInterface, withFlashContext } from '@amzn/awscat-react-components';
import { Flashbar, FlashbarProps, Link } from '@amzn/awsui-components-react';
import React from 'react';

import { AppLabelsContextInterface, withAppLabelsContext } from '../common/AppLabelsContext';

const KTLO_BANNER_CONTENT = (
    <>
        AWS Assessment Tool is currently in maintenance mode. We are committed to keeping it reliable and secure, but no new features will be
        developed. You can still reach out to us through the slack channel{' '}
        <Link href='https://amzn-aws.slack.com/archives/aws-assessment-tool-a2t' external>
            #aws-assessment-tool-a2t
        </Link>{' '}
        and{' '}
        <Link href='https://w.amazon.com/bin/view/AWS/Teams/Proserve/CustomerEngineering/Tooling/A2T/OfficeHours' external>
            office hours
        </Link>
        .
    </>
);

const KTLO_DISMISSED_KEY = 'awscat-ktlo-banner-dismissed';

function FlashMessages(props: FlashContextInterface & AppLabelsContextInterface) {
    const [ktloDismissed, setKtloDismissed] = React.useState(() => {
        try {
            return localStorage.getItem(KTLO_DISMISSED_KEY) === 'true';
        } catch {
            return false;
        }
    });

    const flashes = props.flash.flashes;
    const items: FlashbarProps.MessageDefinition[] = flashes.map((flash) => {
        const id = flash.id;
        const item: FlashbarProps.MessageDefinition = {
            type: flash.type,
            dismissible: true,
            dismissLabel: props.appLabels.user_actions.dismiss,
            onDismiss: () => {
                props.flash.remove(id);
            },
            header: flash.header,
            content: flash.content,
        };
        return item;
    });

    const ktloBanner: FlashbarProps.MessageDefinition = {
        type: 'warning',
        dismissible: true,
        dismissLabel: props.appLabels.user_actions.dismiss,
        onDismiss: () => {
            try {
                localStorage.setItem(KTLO_DISMISSED_KEY, 'true');
            } catch {
                // Ignore storage errors
            }
            setKtloDismissed(true);
        },
        content: KTLO_BANNER_CONTENT,
    };

    const allItems = ktloDismissed ? items : [ktloBanner, ...items];
    return <Flashbar items={allItems} />;
}

export default withFlashContext(withAppLabelsContext(FlashMessages));
